export abstract class StrapiProvider {
  readonly strapiBaseUrl: string;
  readonly strapiApiUrl: string;
}